<template>
    <div id="Nonexistent">
        <h2></h2>
    </div>
</template>

<script>
export default {
   name:'Nonexistent'
}
</script>

<style scoped>
#Nonexistent{
    min-height: 100vh;
    width: 100%;
    background: url('../../assets/img/404.jpg') center/cover
}
</style>